"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAbsoluteURL = void 0;
var isAbsoluteURL = function isAbsoluteURL(url) {
  try {
    var parsed = new URL(url);
    return !!parsed;
  } catch (_unused) {
    return false;
  }
};
exports.isAbsoluteURL = isAbsoluteURL;